import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon', 'feedback']
  static values = {
    min: Number,
    defaultColorClass: { type: String, default: '' },
  }

  connect() {
    if (this.hasFeedbackTarget) this.validate();
  }

  toggle() {
    if (this.inputTarget.type === 'password') {
      this.inputTarget.type = 'text';
      this.toggleClass();
      this.hideIconTarget.focus();
    } else {
      this.inputTarget.type = 'password';
      this.toggleClass();
      this.showIconTarget.focus();
    }
  }

  toggleClass() { // needs to be done before moving the focus
    this.showIconTarget.classList.toggle('d-none');
    this.hideIconTarget.classList.toggle('d-none');
  }

  validate() {
    if (!this.hasFeedbackTarget) return;

    const length = this.inputTarget.value.length;
    const isValid = length >= this.minValue;
    const isTooShort = length > 0 && !isValid;

    this.feedbackTarget.classList.toggle('d-none', isValid);
    this.feedbackTarget.classList.toggle('text-danger', isTooShort);

    if (this.defaultColorClassValue) {
      this.feedbackTarget.classList.toggle(this.defaultColorClassValue, !isTooShort);
    }
  }
}
